module.exports = require("./lib/babel/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/polyfill.js
 ** module id = 2
 ** module chunks = 0
 **/